import { render, staticRenderFns } from "./ScoreAnimation.vue?vue&type=template&id=38a88dcb&scoped=true"
import script from "./ScoreAnimation.vue?vue&type=script&lang=ts"
export * from "./ScoreAnimation.vue?vue&type=script&lang=ts"
import style0 from "./ScoreAnimation.vue?vue&type=style&index=0&id=38a88dcb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a88dcb",
  null
  
)

export default component.exports